import {TimeZoneActionTypes} from "../constants/TimeZoneActionTypes";

export const setTimeZone = (data) => {
  return {
      type: TimeZoneActionTypes.SET_TIME_ZONE,
      payload: data,
  }
}